import React, { useEffect, useState } from "react";
//import "./addNewEmployee.css";
import { Form, Spinner } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faClipboardUser,
  faPercent,
  faUserPlus,
} from "@fortawesome/free-solid-svg-icons";
import Title from "../../components/title";
import RegisterTextbox from "../../components/RegisterTextBox";
import UploadInput from "../../components/UploadInput";
import RegisterSelect from "../../components/RegisterSelect";
import { useParams } from "react-router";
import CustomButton from "../../components/CustomButton";

import { useNavigate } from "react-router";
import API from "../../api/axiosConfig";
import TestPreloader from "../TestPreLoader/TestPreLoader";
import "react-datepicker/dist/react-datepicker.css";

function Volunteers() {
  const [activeTab, setActiveTab] = useState(0);
  const [error, setError] = useState({});
  const { startingTab } = useParams();

  const navigate = useNavigate();
  const [message, setMessage] = useState("");
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [iban, setIban] = useState("");
  const [address, setAddress] = useState("");
  const [nationality, setNationality] = useState("");
  const [qualification, setQualification] = useState("");
  const [upload, setUpload] = useState("");


  const [workDate, setWorkDate] = useState(
    new Date().toISOString().substr(0, 10)
  );
  const [dob, setDob] = useState(new Date().toISOString().substr(0, 10));
  const [status, setStatus] = useState(0);
  const [idexpireDate, setIdexpireDate] = useState(
    new Date().toISOString().substr(0, 10)
  );
  const [jobtitle, setJobtitle] = useState("");
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [idtype, setIdtype] = useState(0);
  const [idnumber, setIdnumber] = useState('');
  const [gender, setGender] = useState('');
  const [empid, setEmpid] = useState('');
  const [expirehire, setExpirehire] = useState(new Date().toISOString().substr(0, 10));
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [city, setCity] = useState("");
  const [region, setRegion] = useState("");
  const [country, setCountry] = useState("");
  const [totalworkhours, setTotalWorkHours] = useState("");
  const [rewards, setRewards] = useState("");
  const [notes, setNotes] = useState("");
  const [upload2, setUpload2] = useState("");
  const [phone, setPhone] = useState("");







  




  const handleNextTab = async (e) => {
    e.preventDefault();


    setIsSubmitting(true);
    const mFormData = new FormData();
    mFormData.append("name", name);
    mFormData.append("dateofbirth", dob);
    mFormData.append("dateofhire", workDate);
    mFormData.append("socialstatus", status);
    mFormData.append("phone", phone);
    mFormData.append("iban", iban);
    mFormData.append("idexpiredate", idexpireDate);
    mFormData.append("gender", gender);
    mFormData.append("idtype", idtype);
    mFormData.append("idnumber", idnumber);
    mFormData.append("address", address);
    mFormData.append("email", email);
    mFormData.append("nationality", nationality);
    mFormData.append("type", jobtitle);
    mFormData.append("qualification", qualification);
    mFormData.append("expirehire", expirehire);
    mFormData.append("profile", upload);
    mFormData.append("city", city);
    mFormData.append("region", region);
    mFormData.append("country", country);
    mFormData.append("totalworkhours", totalworkhours);
    mFormData.append("rewards", rewards);
    mFormData.append("notes", notes);
    mFormData.append("upload", upload2);
    try {
      const res = API.post("/volunteers/store", mFormData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      const data = await res;
      if (data.status === 200) {
        navigate("/hrreport/volunteers")
      } else {
        setError(data.data.errors);
    }} catch (error) {
      console.error(error);
      setIsSubmitting(false);
      setError(error.response.data.errors);
      setMessage(error.response.data.message);
    }
  };
  const [salarydescription, setSalarydescription] = useState("");
  const [type, setType] = useState("");



  return (
  <>
    <div className="addnewemployee">
      

      <div className="addnewemployee-content">
        {activeTab === 0 && (
          <Form onSubmit={handleNextTab} encType="multipart/form-data">
            <div className="addempTitle">
              <Title
                title="البيانات العامة للمتطوع"
                className="marketingtitle"
                icon={<FontAwesomeIcon icon={faUserPlus} />}
              />{" "}
              <div className="addnewemployee-form1">
                <div className="addnewemployee-sec1">
                  <RegisterTextbox
                    parentStyle={{
                      width: "80%",
                    }}
                    id="empname"
                    label="إسم المتطوع"
                    type="text"
                    stylee={{
                      width: "55%",
                    }}
                    name="name"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                  />

                  {error && error.name && (
                    <div
                      style={{
                        color: "red",
                        fontSize: "12px",
                        marginTop: "5px",
                        marginBottom: "5px",
                      }}
                    >
                      {error.name}
                    </div>
                  )}
                 
                  <p className="datelable">تاريخ الميلاد</p>
                  <input
                    type="date"
                    id="date"
                    onChange={(e) => setDob(e.target.value)}
                    value={dob}
                    className="custom-datepicker"
                    style={{ width: "80%", height: "42px" }}
                  />
                  {error && error.dob && (
                    <div
                      style={{
                        color: "red",
                        fontSize: "12px",
                        marginTop: "5px",
                        marginBottom: "5px",
                      }}
                    >
                      {error.dob}
                    </div>
                  )}
                 
                  <p className="datelable">تاريخ الإلتحاق بالعمل</p>
                  <input
                    type="date"
                    id="date"
                    onChange={(e) => setWorkDate(e.target.value)}
                    value={workDate}
                    className="custom-datepicker"
                    style={{ width: "80%", height: "42px" }}
                  />
                  {error && error.workDate && (
                    <div
                      style={{
                        color: "red",
                        fontSize: "12px",
                        marginTop: "5px",
                        marginBottom: "5px",
                      }}
                    >
                      {error.workDate}
                    </div>
                  )}
                 
                  <p className="datelable">تاريخ انتهاء التعاقد</p>
                  <input
                    type="date"
                    id="date"
                    onChange={(e) => setExpirehire(e.target.value)}
                    value={expirehire}
                    className="custom-datepicker"
                    style={{ width: "80%", height: "42px" }}
                  />
                  {error && error.expirehire && (
                    <div
                      style={{
                        color: "red",
                        fontSize: "12px",
                        marginTop: "5px",
                        marginBottom: "5px",
                      }}
                    >
                      {error.expirehire}
                    </div>
                  )}
                  <RegisterSelect
                    id="status"
                    label="الحالة الإجتماعية"
                    stylee={{ width: "55%" }}
                    parentStyle={{ width: "80%" }}
                    options={[
                      { value: "", label: "اختر الحالة الاجتماعية" },
                      { value: 1, label: "متزوج" },
                      { value: 2, label: "أرمل" },
                      { value: 3, label: "مطلق" },
                      { value: 4, label: "اعزب" },
                    ]}
                    value={status}
                    onChange={(e) => setStatus(e.target.value)}
                  />
                  {error && error.status && (
                    <div
                      style={{
                        color: "red",
                        fontSize: "12px",
                        marginTop: "5px",
                        marginBottom: "5px",
                      }}
                    >
                      {error.status}
                    </div>
                  )}
                  <RegisterTextbox
                    parentStyle={{
                      width: "80%",
                      direction: "ltr",
                    }}
                    id="mobnum"
                    label="رقم الجوال"
                    type="number"
                    stylee={{
                      width: "55%",
                    }}
                    customPrefixLeft="4px"
                   value={phone}
                    onChange={(e) => setPhone(e.target.value)}
                    onBlur={(e) => {
                      if (e.target.value.length !== 10) {
                        setError((prevState) => ({
                          ...prevState,
                          mobnum: "رقم الجوال يجب ان يكون 10 أرقام",
                        }));
                      } else {
                        setError((prevState) => ({
                          ...prevState,
                          mobnum: "",
                        }));
                      }
                    }}
                    prefix="+966"
                    // flag={FlagSu}
                  />
                  {error.phone && (
                    <div style={{ color: "red", fontSize: "0.8em" }}>
                      {error.phone ==
                      "رقم الهاتف يجب ان يكون 10 ارقام على الاقل"
                        ? "رقم الجوال يجب ان يكون 10 ارقام على الاقل"
                        : error.phone}
                    </div>
                  )}
                  <RegisterTextbox
                    parentStyle={{
                      width: "80%",
                    }}
                    id="iban"
                    label="رقم IBAN"
                    type="number"
                    stylee={{
                      width: "55%",
                    }}
                    name="iban"
                    value={iban}
                    onChange={(e) => setIban(e.target.value)}
                  />
                  {error && error.iban && (
                    <div
                      style={{
                        color: "red",
                        fontSize: "12px",
                        marginTop: "5px",
                        marginBottom: "5px",
                      }}
                    >
                      {error.iban}
                    </div>
                  )}
                 
                  <p className="datelable">تاريخ انتهاء الهوية</p>
                  <input
                    type="date"
                    id="date"
                    onChange={(e) => setIdexpireDate(e.target.value)}
                    value={idexpireDate}
                    className="custom-datepicker"
                    style={{ width: "80%", height: "42px" }}
                  />
                   <RegisterTextbox
                    parentStyle={{
                      width: "80%",
                    }}
                    id="rewards"
                    label="المكافأة المالية"
                    type="text"
                    stylee={{
                      width: "55%",
                    }}
                    name="rewards"
                    value={rewards}
                    onChange={(e) => setRewards(e.target.value)}
                  />
                  {error && error.rewards && (
                    <div
                      style={{
                        color: "red",
                        fontSize: "12px",
                        marginTop: "5px",
                        marginBottom: "5px",
                      }}
                    >
                      {error.rewards}
                    </div>
                  )}
                   <RegisterTextbox
                    parentStyle={{
                      width: "80%",
                    }}
                    id="qualification"
                    label="الشهادة"
                    type="text"
                    stylee={{
                      width: "55%",
                    }}
                    name="qualification"
                    value={qualification}
                    onChange={(e) => setQualification(e.target.value)}
                  />
                  {error && error.qualification && (
                    <div
                      style={{
                        color: "red",
                        fontSize: "12px",
                        marginTop: "5px",
                        marginBottom: "5px",
                      }}
                    >
                      {error.qualification}
                    </div>
                  )}
                   <RegisterTextbox
                    parentStyle={{
                      width: "80%",
                    }}
                    id="notes"
                    label="ملاحظات"
                    type="text"
                    stylee={{
                      width: "55%",
                    }}
                    name="notes"
                    value={notes}
                    onChange={(e) => setNotes(e.target.value)}
                  />
                  {error && error.notes && (
                    <div
                      style={{
                        color: "red",
                        fontSize: "12px",
                        marginTop: "5px",
                        marginBottom: "5px",
                      }}
                    >
                      {error.notes}
                    </div>
                  )}
                </div>
                <div className="addnewemployee-sec1">
                 
                  <RegisterSelect
                    id="status"
                    label="النوع"
                    stylee={{ width: "55%" }}
                    parentStyle={{ width: "80%" }}
                    options={[
                      { value: "", label: "اختر النوع" },
                      { value: "0", label: "ذكر" },
                      { value: "1", label: "أنثي" },
                    ]}
                    value={gender}
                    onChange={(e) => setGender(e.target.value)}
                  />
                  {error && error.gender && (
                    <div
                      style={{
                        color: "red",
                        fontSize: "12px",
                        marginTop: "5px",
                        marginBottom: "5px",
                      }}
                    >
                      {error.gender}
                    </div>
                  )}
                  <RegisterSelect
                    id="status"
                    label="الهوية"
                    stylee={{ width: "55%" }}
                    parentStyle={{ width: "80%" }}
                    options={[
                      { value: "", label: "اختر نوع الهوية" },
                      { value: "1", label: "رقم الهوية" },
                      { value: "2", label: "رقم الاقامة" },
                    ]}
                    value={idtype}
                    onChange={(e) => setIdtype(e.target.value)}
                  />
                  {error && error.idtype && (
                    <div
                      style={{
                        color: "red",
                        fontSize: "12px",
                        marginTop: "5px",
                        marginBottom: "5px",
                      }}
                    >
                      {error.idtype}
                    </div>
                  )}
                  <RegisterTextbox
                    parentStyle={{
                      width: "80%",
                    }}
                    id="idnumber"
                    label={
                      idtype == 0
                        ? "الرقم"
                        : idtype == 1
                        ? "رقم الهوية"
                        : "رقم الاقامة"
                    }
                    type="text"
                    stylee={{
                      width: "55%",
                    }}
                    name="idnumber"
                    value={idnumber}
                    onChange={(e) => setIdnumber(e.target.value)}
                  />
                  {error && error.idnumber && (
                    <div
                      style={{
                        color: "red",
                        fontSize: "12px",
                        marginTop: "5px",
                        marginBottom: "5px",
                      }}
                    >
                      {error.idnumber ==
                      "The idnumber field must be at least 10 characters."
                        ? "رقم الهوية يجب ان يكون 10 ارقام على الاقل "
                        : error.idnumber}
                    </div>
                  )}

                  <RegisterTextbox
                    parentStyle={{
                      width: "80%",
                    }}
                    id="address"
                    label="العنوان"
                    type="text"
                    stylee={{
                      width: "55%",
                    }}
                    name="address"
                    value={address}
                    onChange={(e) => setAddress(e.target.value)}
                  />
                  {error && error.address && (
                    <div
                      style={{
                        color: "red",
                        fontSize: "12px",
                        marginTop: "5px",
                        marginBottom: "5px",
                      }}
                    >
                      {error.address}
                    </div>
                  )}

                  <RegisterTextbox
                    parentStyle={{
                      width: "80%",
                    }}
                    id="empemail"
                    label="البريد الإلكتروني"
                    type="email"
                    stylee={{
                      width: "55%",
                    }}
                    name="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                  {error && error.email && (
                    <div
                      style={{
                        color: "red",
                        fontSize: "12px",
                        marginTop: "5px",
                        marginBottom: "5px",
                      }}
                    >
                      {error.email}
                    </div>
                  )}

                  <RegisterTextbox
                    parentStyle={{
                      width: "80%",
                    }}
                    id="empname"
                    label="الجنسية"
                    type="text"
                    stylee={{
                      width: "55%",
                    }}
                    name="nationality"
                    value={nationality}
                    onChange={(e) => setNationality(e.target.value)}
                  />
                  {error && error.nationality && (
                    <div
                      style={{
                        color: "red",
                        fontSize: "12px",
                        marginTop: "5px",
                        marginBottom: "5px",
                      }}
                    >
                      {error.nationality}
                    </div>
                  )}
                  <RegisterSelect
                    id="jobtitle"
                    label=" نوع التطوع"
                    parentStyle={{
                      width: "80%",
                    }}
                    stylee={{ width: "55%" }}
                    options={[
                      { value: "", label: " اختر نوع التطوع " },
                      { value: "0", label: " لا يوجد" },
                      { value: "1", label: "تطوع عام" },
                      { value: "2", label: "تطوع تخصصي" },
                    ]}
                    name="jobtitle"
                    value={jobtitle}
                    onChange={(e) => setJobtitle(e.target.value)}
                  />
                  {error && error.jobtitle && (
                    <div
                      style={{
                        color: "red",
                        fontSize: "12px",
                        marginTop: "5px",
                        marginBottom: "5px",
                      }}
                    >
                      {error.jobtitle}
                    </div>
                  )}
                  <RegisterTextbox
                    parentStyle={{
                      width: "80%",
                    }}
                    id="degree2"
                    label="المدينة"
                    type="text"
                    stylee={{
                      width: "55%",
                    }}
                    name="city"
                    value={city}
                    onChange={(e) => setCity(e.target.value)}
                  />
                  {error && error.city && (
                    <div
                      style={{
                        color: "red",
                        fontSize: "12px",
                        marginTop: "5px",
                        marginBottom: "5px",
                      }}
                    >
                      {error.city}
                    </div>
                  )}
                   <RegisterTextbox
                    parentStyle={{
                      width: "80%",
                    }}
                    id="degree1"
                    label="المنطقة"
                    type="text"
                    stylee={{
                      width: "55%",
                    }}
                    name="region"
                    value={region}
                    onChange={(e) => setRegion(e.target.value)}
                  />
                  {error && error.region && (
                    <div
                      style={{
                        color: "red",
                        fontSize: "12px",
                        marginTop: "5px",
                        marginBottom: "5px",
                      }}
                    >
                      {error.region}
                    </div>
                  )}
                   <RegisterTextbox
                    parentStyle={{
                      width: "80%",
                    }}
                    id="country"
                    label="الدولة"
                    type="text"
                    stylee={{
                      width: "55%",
                    }}
                    name="country"
                    value={country}
                    onChange={(e) => setCountry(e.target.value)}
                  />
                  {error && error.country && (
                    <div
                      style={{
                        color: "red",
                        fontSize: "12px",
                        marginTop: "5px",
                        marginBottom: "5px",
                      }}
                    >
                      {error.country}
                    </div>
                  )}
                   <RegisterTextbox
                    parentStyle={{
                      width: "80%",
                    }}
                    id="totalworkhours"
                    label="عدد ساعات العمل"
                    type="text"
                    stylee={{
                      width: "55%",
                    }}
                    name="totalworkhours"
                    value={totalworkhours}
                    onChange={(e) => setTotalWorkHours(e.target.value)}
                  />
                  {error && error.totalworkhours && (
                    <div
                      style={{
                        color: "red",
                        fontSize: "12px",
                        marginTop: "5px",
                        marginBottom: "5px",
                      }}
                    >
                      {error.totalworkhours}
                    </div>
                  )}
                  
                </div>
              </div>
              <div className="addnewemployee-sec2">
                <UploadInput
                  id="empdocumentUpload"
                  parentStyle={{
                    marginBottom: "20px",
                    display: "flex",
                    alignItems: "center",
                  }}
                  label="رفع الصورة الشخصية"
                  name="upload"
                  onChange={(e) => {
                    setUpload(e.target.files[0]);
                  }}
                  accept="image/*"
                />
                 <UploadInput
                  id="empdocumentUpload2"
                  parentStyle={{
                    marginBottom: "20px",
                    display: "flex",
                    alignItems: "center",
                  }}
                  label="رفع الشهادة"
                  name="upload2"
                  onChange={(e) => {
                    setUpload2(e.target.files[0]);
                  }}
                  accept="image/*"
                />
              </div>
            </div>
            <div className="addnewemployee-btnCon">
              {isSubmitting ? (
                <Spinner animation="border" variant="primary" />
              ) : (
                <CustomButton text="حفظ" />
              )}
            </div>
          </Form>
        )}

        
      </div>
    </div>
    </>
  );
}

export default Volunteers;
